import { apiSlice } from "../../app/api/apiSlice";

export const enhancedConditionAttachmentUploadUrlApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionAttachmentUploadUrl: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/enhanced_condition_attachment_upload_url/${credentials?.loanGuid}/`,
					method: "POST",
					body: {
						user_email: String(credentials?.user_email ?? "").trim(),
						file: {
							contentType: credentials?.file?.contentType,
							name: credentials?.file?.name,
							size: credentials?.file?.size,
						},
						title: credentials?.title,
						assignTo: {
							entityId: credentials?.assignTo?.entityId,
							entityType: credentials?.assignTo?.entityType,
						},
					},
				}),
			}),
		}),
	});

export const { useEnhancedConditionAttachmentUploadUrlMutation } =
	enhancedConditionAttachmentUploadUrlApiSlice;
